export default __webpack_public_path__ + "static/media/treat-yourself-480w.af816bf2.avif";